/** Группы серий конспектов на /konspekty/ (только UI). */

/** Явный порядок внутри группы (кроме еге-* — там по номеру). */
const GROUP_SPECS = [
  {
    id: 'osnovy',
    title: 'Основы',
    slugs: ['osnovy-python', 'osnovy-informatika', 'cpp-school'],
  },
  {
    id: 'ege',
    title: 'ЕГЭ',
    slugs: ['osnovy-prog-zadachi', 'regulyarki-ege'],
    /** Остальные: slug начинается с ege- */
    matchPrefix: 'ege-',
  },
  {
    id: 'oge',
    title: 'ОГЭ',
    slugs: [
      'oge-python',
      'oge-1',
      'oge-2',
      'oge-3',
      'oge-4',
      'oge-5',
      'oge-6',
      'oge-7',
      'oge-8',
      'oge-9',
      'oge-10',
      'oge-11',
      'oge-12',
      'oge-13',
      'oge-14',
      'oge-15',
      'oge-16',
    ],
  },
  {
    id: 'games',
    title: 'Создание игр',
    slugs: ['code-canvas-game'],
  },
];

function egeSortKey(slug) {
  const m = String(slug || '').match(/^ege-(\d+)/);
  if (m) return Number(m[1]);
  return 1000;
}

/**
 * @param {{ slug: string, name: string }[]} seriesTags
 * @returns {{ id: string, title: string, tags: { slug: string, name: string }[] }[]}
 */
export function groupSeriesTags(seriesTags) {
  const bySlug = new Map();
  for (const t of seriesTags || []) {
    if (t?.slug) bySlug.set(t.slug, t);
  }

  const used = new Set();
  const groups = [];

  for (const spec of GROUP_SPECS) {
    const tags = [];
    for (const slug of spec.slugs) {
      const t = bySlug.get(slug);
      if (t) {
        tags.push(t);
        used.add(slug);
      }
    }
    if (spec.matchPrefix) {
      const prefixed = [];
      for (const [slug, t] of bySlug) {
        if (used.has(slug)) continue;
        if (slug.startsWith(spec.matchPrefix)) {
          prefixed.push(t);
          used.add(slug);
        }
      }
      prefixed.sort((a, b) => egeSortKey(a.slug) - egeSortKey(b.slug)
        || String(a.name).localeCompare(String(b.name), 'ru'));
      tags.push(...prefixed);
    }
    if (tags.length) {
      groups.push({ id: spec.id, title: spec.title, tags });
    }
  }

  const other = [];
  for (const [slug, t] of bySlug) {
    if (!used.has(slug)) other.push(t);
  }
  if (other.length) {
    other.sort((a, b) => String(a.name).localeCompare(String(b.name), 'ru'));
    groups.push({ id: 'other', title: 'Другое', tags: other });
  }

  return groups;
}
